import { render, staticRenderFns } from "./editUrl.vue?vue&type=template&id=55ec6589&scoped=true&"
import script from "./editUrl.vue?vue&type=script&lang=js&"
export * from "./editUrl.vue?vue&type=script&lang=js&"
import style0 from "./editUrl.vue?vue&type=style&index=0&id=55ec6589&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ec6589",
  null
  
)

export default component.exports